<template>
    <hts-drawer
        v-model="visible"
        :title="$t('labels.addCostingGasoline')"
        :rules="rulesCostingGasoline"
        :submit="submit"
        @close="close">
        <div
            v-loading="!visible"
            class="grid gap-4 grid-cols-1">
            <hts-form-input
                v-model="formData.amount"
                :label="$t('labels.amountGasolineNotVat')"
                required
                prop="amountGasolineNotVat"
                name="amountGasolineNotVat"
                type="number"
                :color="props.color" />
            <hts-form-date
                v-model="formData.availability"
                :label="$t('labels.effectiveStartTime')"
                type="datetime"
                time-format="HH:mm"
                required
                prop="effectiveStartTime"
                name="effectiveStartTime"
                :color="props.color" />
        </div>
    </hts-drawer>
</template>

<script setup lang="ts">
import { ICreateCostingGasoline } from '~/pages/trucker-[id]/cost/-component/imports/form'

const visible = ref(false)
const props = defineProps({
  codeCooperator: {
    type: String,
    default: ''
  }
})
const resetForm = () => {
  Object.assign(formData, {
    amount: null,
    availability: null
  })
}
const formData = reactive<ICreateCostingGasoline>({
  amount: null,
  availability: null
})
const close = () => {
  visible.value = false
}

const emits = defineEmits(['refreshTables'])

const open = () => {
  visible.value = true
}
defineExpose({
  open
})

const submit = async () => {
  const api = $url.cost.gasoline.createGasoline
  const data: any = await $api(api, { body: formData })
  const resData = data?.data?.value

  if (resData?.success) {
    process.client && $toast().success($t('labels.addCostingGasolineSuccess'))
    resetForm()
    close()
    emits('refreshTables')
  }
}

const rulesCostingGasoline = {
  amountGasolineNotVat: 'required|max_value:999999999999999|gt:0',
  effectiveStartTime: `required|nextDays:7-${$t('labels.priceCreationDate')}`
}

const a = {
  _id: '64ae11a03eb30b1252b4cfae',
  company: '62f9bbe7adcfab73d748fd96',
  typeCommodity: 'NORMAL',
  name: 'TEST 25',
  prices: {
    VEHICLE: {
      calculatedType: 'TRIP',
      prices: {
        '64240d48ae82838bcca07e9e': {
          amount: 100000000000000,
          name: 'bbbbbbb'
        },
        '64ae0dbfcdf265548867c059': {
          amount: 100000000000000,
          name: 'aaa'
        },
        '64ae0deacdf265548867c0d3': {
          amount: 345646,
          name: 'ddd'
        }
      },
      priceDetails: [
        {
          type: ['64240d48ae82838bcca07e9e', '64ae0dbfcdf265548867c059'],
          amount: 100000000000000
        },
        {
          type: ['64ae0deacdf265548867c0d3'],
          amount: 345646
        }
      ],
      priceTargets: ['64240d48ae82838bcca07e9e', '64ae0dbfcdf265548867c059', '64ae0deacdf265548867c0d3']
    }
  }
}
</script>
